import Vue from 'vue'
import VueRouter from 'vue-router'
import router from '@/router/index.js'
import staticRouter from './staticRouter'
//重置路由 退出登录时重置路由
function resetRouter() {
	const newRouter = new VueRouter({
		routes: staticRouter
	});
	router.matcher = newRouter.matcher;
}

export default resetRouter
